export default (function (_a) {
    var truncate = _a.truncate;
    return truncate &&
        "\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n";
});
